import { TFunction } from 'i18next';
import { StoryCard } from '../../services';
import { getStoryCardTitle } from './getStoryCardTitle';

interface GetStoryCardNameArgs {
  card: StoryCard;
  t: TFunction;
}

export const getStoryCardName = ({ card, t }: GetStoryCardNameArgs) =>
  getStoryCardTitle(card)?.trim() || t(`cardTypes.${card.type.toLowerCase()}`);
